module.exports = __webpack_public_path__ + "static/randomsculptureclublogo-3d4f38fd6c7c7ad9db555d56931f6e80.png";